document.addEventListener("DOMContentLoaded", function () {

  $('.js-carousel').each(function () {

    let $this = $(this);

    if ($this.hasClass('owl-loaded')) {
      $this.trigger('destroy.owl.carousel');
    }

    $this.owlCarousel({
      nav: $this.data('nav'),
      dots: $this.data('dots'),
      loop: false,
      rewind: false,
      margin: 16,
      autoHeight: false,
      smartSpeed: 500,
       slideBy: 1,
       dotsEach: 1,
      navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
          <path stroke="#113700" fill="#113700" d="M12.0078 4.68652C12.0934 4.68658 12.1668 4.71285 12.249 4.79492C12.3313 4.88086 12.3574 4.95797 12.3574 5.04395C12.3573 5.13078 12.3308 5.20478 12.249 5.28711L5.8877 11.6484H19.2979C19.4194 11.6485 19.4945 11.6838 19.5586 11.7471C19.6207 11.8084 19.6553 11.8801 19.6553 12C19.6553 12.1199 19.6207 12.1916 19.5586 12.2529C19.4945 12.3162 19.4194 12.3515 19.2979 12.3516H5.8877L12.2432 18.707V18.7061C12.3254 18.7885 12.3537 18.8653 12.3545 18.957V18.958C12.355 19.0245 12.3404 19.0829 12.2988 19.1426L12.2471 19.2041C12.1671 19.2851 12.0939 19.3113 12.0049 19.3105C11.9104 19.3096 11.8321 19.2796 11.749 19.1973L4.80078 12.249C4.74762 12.1949 4.72192 12.1527 4.70996 12.124V12.123C4.69485 12.0867 4.68652 12.0466 4.68652 11.999C4.68655 11.9514 4.69516 11.9123 4.70996 11.877V11.876C4.72183 11.8475 4.74729 11.8051 4.80078 11.751L11.751 4.80078C11.8414 4.71356 11.9211 4.68652 12.0078 4.68652Z"></path>
        </svg>`,

        `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
          <path stroke="#113700" fill="#113700" d="M11.9951 4.68945C12.0661 4.69012 12.1279 4.70677 12.1895 4.75L12.251 4.80273L19.1992 11.751C19.2524 11.8051 19.2781 11.8473 19.29 11.876V11.877C19.3052 11.9133 19.3135 11.9534 19.3135 12.001C19.3134 12.0486 19.3048 12.0877 19.29 12.123V12.124C19.2782 12.1525 19.2527 12.1948 19.1992 12.249L12.2451 19.1973C12.1538 19.2875 12.0752 19.3135 11.9922 19.3135C11.9115 19.3134 11.8393 19.2889 11.7559 19.2031L11.751 19.1982L11.6992 19.1377C11.6571 19.0781 11.6426 19.02 11.6426 18.9551C11.6426 18.8904 11.6573 18.8328 11.6992 18.7734L11.751 18.7129L18.1123 12.3516H4.70215C4.58005 12.3515 4.50781 12.3164 4.44727 12.2559H4.44629C4.38542 12.195 4.35059 12.122 4.35059 12C4.35059 11.878 4.38542 11.805 4.44629 11.7441H4.44727C4.50782 11.6836 4.58005 11.6485 4.70215 11.6484H18.1123L11.7568 5.29297C11.6955 5.23162 11.6637 5.17322 11.6514 5.1084L11.6455 5.04102C11.6446 4.95107 11.6708 4.87748 11.751 4.79688L11.752 4.7959C11.8321 4.71531 11.9055 4.68868 11.9951 4.68945Z"></path>
        </svg>`
      ],

      responsive: {
        0: {
          items: 1.2,
          margin:  16
          
        },

        768: {
          items: 1.2,
          margin: 16
        },

        1280: {
          items: 3,
          margin: $this.data('margin')
        },

        1920: {
          items: 3,
          margin: $this.data('margin')
        }
      }

    });

  });

});
